// extracted by mini-css-extract-plugin
export default {"button":"Button_button__0o2kG","secondary":"Button_secondary__yOplr","accent":"Button_accent__qATtP","more":"Button_more__CymY7"};